import type { UserRole } from '~/types/userRole'
import type { Chat } from '~/types/chat'

export const isUserRole = computed(() => {
  const { userInfo } = storeToRefs(useUserStore())

  return (roles: UserRole | UserRole[]) => {
    if (Array.isArray(roles)) {
      return [...roles].includes(userInfo.value.role)
    }

    return userInfo.value.role === roles
  }
})

export const mergeArrays = (a, b, predicate = (a, b) => a === b) => {
  const c = [...a] // copy to avoid side effects
  // add all items from B to copy C if they're not already present
  b.forEach(bItem =>
    c.some(cItem => predicate(bItem, cItem)) ? null : c.push(bItem)
  )
  return c
}

export function findChatRoomByOppositeUserId(chatList, userId) {
  for (let i = 0; i < chatList.length; i++) {
    const participant = chatList[i].participants.find(
      participant => participant.cognitoUserId === userId
    )
    if (participant) {
      return chatList[i]
    }
  }
  return null
}

export function findChatRoomByRoomId(chatList: Chat[], roomId: string) {
  console.log('OO', chatList, roomId)
  const chat = chatList.find(chat => chat._id === roomId)
  if (chat) {
    return chat
  }
  return null
}

export default {
  isUserRole,
  mergeArrays,
}
